import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { antdTheme, ConfigProviderComponent, DatePickerComponent, DurationDropdown } from '../index';
import './startDateDurationPicker.scss';
import RefreshButton from '../refresh-button/RefreshButton';
import { getIndexByKeyValue } from '../../../utils/commonFunctions';
import { useDurationOptions } from '../duration-dropdown/DurationDropdown';

interface StartDateDurationPickerProps {
    selectedTimeRange?: any;
    selectedTimeDuration?: string;
    onStartChangeEvent?: (date: any, dateString: string | string[]) => void;
    onDurationChangeEvent?: (duration: string) => void;
    disabledDate?: (current: any) => boolean;
    disabledTime?: (date: any) => any;
    style?: React.CSSProperties;
    className?: string;
    refresh?: () => void;
}


const StartDateDurationPicker = ({
    selectedTimeRange,
    selectedTimeDuration,
    ...otherProps
}: StartDateDurationPickerProps) => {
    const { t } = useTranslation();
    const durationOptions = useDurationOptions();
    const startPointValue = useMemo(() => {
        if (selectedTimeRange) {
            return selectedTimeRange?.[0];
        }
    }, [selectedTimeRange]);

    const selectedTimeDurationObj = useMemo(() => {
        const index = getIndexByKeyValue('value', selectedTimeDuration, durationOptions);

        return index !== -1 ? durationOptions[index] : {};
    }, [selectedTimeDuration, durationOptions]);

    return (
        <>
            <ConfigProviderComponent theme={antdTheme}>
                <div className='startDateDurationRangeFilter'>

                    <div className='startDateDurationContainerBox'>
                        <div className='startDateDurationContainer'>
                            <div className='startDateDurationItem'>
                                <div className='durationLabel'>{t('shared.duration.durationLabel')}</div>
                                <DurationDropdown
                                    onTimeDurationChange={otherProps.onDurationChangeEvent}
                                    selectedTimeDuration={selectedTimeDurationObj}
                                    disabledDurationOptions={[]}
                                />
                            </div>
                            <div className='startDateDurationItem start'>
                                <div className='durationLabel'>{t('shared.duration.startPointLabel')}</div>
                                <DatePickerComponent
                                    showTime={{
                                        format: 'HH:mm:ss',
                                    }}
                                    value={startPointValue}
                                    onChangeEvent={otherProps?.onStartChangeEvent}
                                    format='DD-MMM-YYYY HH:mm:ss'
                                    disabledDate={otherProps?.disabledDate}
                                    disabledTime={otherProps?.disabledTime}
                                    style={otherProps?.style}
                                    className={otherProps?.className}
                                />
                            </div>
                            <div className='startDateDurationItem begin'>
                                <div className='durationLabel' />
                                {otherProps.refresh && <RefreshButton className='refresh-button' refresh={otherProps.refresh} />}
                            </div>
                        </div>
                    </div>
                </div>
            </ConfigProviderComponent>
        </>
    );
};

export default StartDateDurationPicker;
